import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import useSession from "./useSession";

const METADATA_CLAIM = "https://www.sunnyrewards.com/app_metadata";

function safeJsonParse(str: string) {
  try {
    return JSON.parse(str);
  } catch {
    return {};
  }
}

export const useUserInfo = () => {
  const { user, isLoggedIn, api } = useSession();

  const auth0User = user as any;
  const auth0ID = auth0User?.sub;
  const email = auth0User?.email;
  const metadata = auth0User?.[METADATA_CLAIM] || {};

  /**
   * getUserById intentionally not used right now
   *
   * const userDetailQuery = useQuery({
   *   queryKey: ["adminUserDetail", auth0ID],
   *   queryFn: () => api.getUserById({ auth0ID, email }),
   *   enabled: !!auth0ID && isLoggedIn,
   * });
   */

  const consumerCode =
    metadata.consumerCode ||
    metadata.consumer_code ||
    undefined;
  const tenantCode =
    metadata.tenantCode ||
    metadata.tenant_code ||
    undefined;

  // consumer summary
  const consumerSummaryQuery = useQuery({
    queryKey: ["consumerSummary", auth0ID],
    queryFn: () =>
      api.consumerSummary({
        authUserId: auth0ID,
        email,
        consumerCode,
        tenantCode,
        consumerId:0
      }),
    enabled: !!auth0ID && isLoggedIn,
  });


  const { tenant, consumer, parsedTenantAttribute, person } = useMemo(() => {
    const summary = consumerSummaryQuery.data;
    const rewardsSummary = summary?.rewardsConsumerSummary || null;
    const benefitsSummary = summary?.benefitConsumerSummary || null;

    const tenant = benefitsSummary?.tenantInfo?.tenant || null;
    const consumer = benefitsSummary?.consumerInfo?.consumer?.[0] || null;
    const person = benefitsSummary?.consumerInfo?.person || null;

    const tenantAttributeRaw =
      tenant?.tenantAttribute ||
      benefitsSummary?.tenantInfo?.tenant?.tenantAttribute ||
      null;

    const parsedTenantAttribute = tenantAttributeRaw
      ? safeJsonParse(tenantAttributeRaw)
      : {};

    return { tenant, consumer, parsedTenantAttribute, person };
  }, [consumerSummaryQuery.data]);

  return {
    tenant,
    consumer,
    parsedTenantAttribute,
    tenantCode,
    consumerCode,
    person,
    loadingInfo: consumerSummaryQuery.isLoading,
    infoError: consumerSummaryQuery.error,

    reloadUserInfo: () => {
      consumerSummaryQuery.refetch();
    },
  } as const;
};
